import _ from "lodash";

import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class ScoreAccounting {
    HttpAdapter = new HttpAdapter();
    baseUrlUsersEvents = `${publicSettings.aws.baseUrls.usersManagement}/users/events`;
    baseUrlAccountingScore = `${publicSettings.aws.baseUrls.accounting}/accounting/score`;

    constructor({ PointsAccountingAnalytics } = {}) {
        this.PointsAccountingAnalytics = PointsAccountingAnalytics;
    }

    async getCustomerEngagement({
        accountingId,
        events = [],
        date = { start: { year, month }, end: { year, month } }
    }) {
        if (!accountingId || !date || !events)
            throw new Error("Missing params");

        const response = await this.HttpAdapter.call(
            `${this.baseUrlUsersEvents}/get-customer-engagement`,
            { accountingId, events, date }
        );

        if (response.message) return [];

        return response.events;
    }

    async getTotalCustomerEngagement({
        accountingId,
        events = [],
        date = { start: { year, month }, end: { year, month } }
    }) {
        if (!accountingId || !date || !events)
            throw new Error("Missing params");

        const response = await this.HttpAdapter.call(
            `${this.baseUrlUsersEvents}/get-total-customers-by-events`,
            { accountingId, events, date }
        );

        if (response.message) return [];

        return response.events;
    }

    async getByAccountingIdAndDate({
        accountingId,
        date = { start: { year, month }, end: { year, month } }
    }) {
        if (!accountingId || !date) throw new Error("Missing params");

        const response = await this.HttpAdapter.call(
            `${this.baseUrlAccountingScore}/get-by-id-date`,
            { accountingId, date }
        );

        if (response.message) return [];

        return response.response;
    }

    _modelerPoints({ scoreData, accountingId }) {
        const points = scoreData.map((score) => {
            return {
                t: new Date(score.date),
                s: "SCORE_ACCOUNTING",
                c: "EMPRESA_NUCONT",
                sc: "ORIGINAL",
                u: new Date(),
                a: accountingId,
                m: {
                    high: score.scoreByCompanies.high,
                    medium: score.scoreByCompanies.medium,
                    low: score.scoreByCompanies.low,
                    total: score.result.total,
                    label: score.result.score
                },
                period: "monthly"
            };
        });

        return _.sortBy(points, "t");
    }

    _modelerPointsCustomerEngagement({ events, accountingId }) {
        const seriesIds = {
            dataInputted: "CUSTOMER_ENGAGEMENT_INSERTED",
            reportShared: "CUSTOMER_ENGAGEMENT_SHARED",
            reportDownloaded: "CUSTOMER_ENGAGEMENT_DOWNLOADED",
            reportShowed: "CUSTOMER_ENGAGEMENT_VIEWED"
        };

        const points = events.map((ev) => {
            return {
                t: new Date(ev.date),
                s: seriesIds[ev.eventType],
                c: "EMPRESA_NUCONT",
                sc: "ORIGINAL",
                u: new Date(),
                a: accountingId,
                m: {
                    v: ev.total
                },
                period: "monthly"
            };
        });

        return _.sortBy(points, "t");
    }

    async populate({ accountingId, date }) {
        const [scoreData, events] = await Promise.all([
            await this.getByAccountingIdAndDate({
                accountingId,
                date
            }),
            await this.getCustomerEngagement({
                accountingId,
                events: [
                    "dataInputted",
                    "reportDownloaded",
                    "reportShared",
                    "reportShowed"
                ],
                date
            })
        ]);

        const scorePoints = this._modelerPoints({ scoreData, accountingId });
        const eventsPoints = this._modelerPointsCustomerEngagement({
            events,
            accountingId
        });

        this.PointsAccountingAnalytics.createMany([
            ...scorePoints,
            ...eventsPoints
        ]);
    }
}
